/* Comforts Kids designs gallery: radiogroup keyboard model and selection sync with Dawn's variant-selects.
   Selecting a card checks the real swatch radio and dispatches a bubbling change, so Dawn's own
   variant flow runs (image, Design line, WhatsApp link). The variant-change handler only updates ARIA
   state and never dispatches anything, so there is no feedback loop. */
(function () {
  'use strict';

  /* Dawn's renderProductInfo focuses the swatch radio after it re-renders (product-info.js), which
     yanks focus (and scroll) away from the gallery card that was chosen. Remember the card so the
     variant-change handler can hand focus back once Dawn is done. */
  var pending = null;
  var PENDING_MS = 10000;

  function reduced() {
    return !!(window.CK && window.CK.prefersReducedMotion && window.CK.prefersReducedMotion());
  }

  function init(root) {
    if (root.__ckDesigns) return;
    root.__ckDesigns = true;

    function cards() {
      return Array.prototype.slice.call(root.querySelectorAll('[role="radio"]'));
    }

    function mark(card) {
      cards().forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function radioFor(card) {
      // Dawn re-renders the swatches on every change: always query fresh.
      return document.querySelector('variant-selects input[type="radio"][value="' + CSS.escape(card.dataset.optionValue) + '"]');
    }

    function select(card, opts) {
      var scroll = !!(opts && opts.scroll);
      mark(card);
      var radio = radioFor(card);
      var info = document.querySelector('product-info');
      if (!radio) {
        if (!info && root.dataset.productUrl) {
          window.location.assign(root.dataset.productUrl + '?variant=' + encodeURIComponent(card.dataset.variantId));
        }
        return;
      }
      if (!radio.checked) {
        pending = { card: card, keepScroll: !scroll, at: Date.now() };
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (scroll && info) {
        var r = info.getBoundingClientRect();
        var offscreen = r.bottom <= 0 || r.top >= window.innerHeight;
        if (offscreen) {
          info.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[role="radio"]');
      if (card && root.contains(card)) select(card, { scroll: true });
    });

    root.addEventListener('keydown', function (e) {
      var card = e.target.closest('[role="radio"]');
      if (!card || !root.contains(card)) return;
      var list = cards();
      var i = list.indexOf(card);
      var target = null;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          target = list[(i + 1) % list.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          target = list[(i - 1 + list.length) % list.length];
          break;
        case 'Home':
          target = list[0];
          break;
        case 'End':
          target = list[list.length - 1];
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          select(card, { scroll: true });
          return;
        default:
          return;
      }
      e.preventDefault();
      target.focus({ preventScroll: false });
      select(target, { scroll: false });
    });
  }

  function restoreFocus(variant) {
    var p = pending;
    pending = null;
    if (!p || Date.now() - p.at > PENDING_MS || p.card.dataset.variantId !== String(variant.id)) return;
    var x = window.scrollX;
    var y = window.scrollY;
    // Dawn calls focus() right after publishing variantChange, in the same task: run after it.
    setTimeout(function () {
      var active = document.activeElement;
      if (!active || !active.matches || !active.matches('variant-selects input')) return;
      if (!document.body.contains(p.card)) return;
      p.card.focus({ preventScroll: true });
      if (p.keepScroll) window.scrollTo(x, y);
    }, 0);
  }

  function initWithin(scope) {
    var roots = scope && scope.querySelectorAll ? scope.querySelectorAll('[data-ck-designs]') : [];
    Array.prototype.forEach.call(roots, init);
  }

  /* Theme editor: a section the owner edits is re-rendered with a new gallery that needs its keyboard
     model; the variant-change sync below always queries the galleries fresh. */
  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  function start() {
    initWithin(document);
    if (!window.CK || !window.CK.onVariantChange) return;
    window.CK.onVariantChange(function (evt) {
      var data = evt && evt.data;
      var variant = data && data.variant;
      if (!variant) return;
      restoreFocus(variant);
      Array.prototype.forEach.call(document.querySelectorAll('[data-ck-designs]'), function (root) {
        var match = root.querySelector('[role="radio"][data-variant-id="' + CSS.escape(String(variant.id)) + '"]');
        if (!match) return;
        Array.prototype.forEach.call(root.querySelectorAll('[role="radio"]'), function (c) {
          var on = c === match;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.setAttribute('tabindex', on ? '0' : '-1');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
